<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Glyphicons</h1>
					<p waBody="m" waText>Glyphicons Halflings &mdash; 250+ monochromatic icons and symbols from Bootstrap 3. CSS web font rendering with glyphicon glyphicon- class prefix.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Glyphicons 1.9.2</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:glyphicons</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.glyphicons</p>
					<p waBody="s" waText>Built on: Glyphicons 1.9.2</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_597" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_598" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;3&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>Glyphicon</h4>
								<p waBody="s" waColorText="quiet" waText>CRTP span-based icon component that renders a Glyphicon via CSS class. Implements IIcon.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">1 props</wa-tag>
									<wa-tag pill variant="neutral">4 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/glyphicons/glyphicon']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>Glyphicons</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 250+ Bootstrap 3 Glyphicons Halflings icon constants with glyphicon glyphicon- CSS class prefix.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">7 props</wa-tag>
									<wa-tag pill variant="neutral">1 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/glyphicons/glyphicons']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>GlyphiconsPageConfigurator</h4>
								<p waBody="s" waColorText="quiet" waText>Page configurator that auto-registers Glyphicons CSS via npm &amp;#64;TsDependency and &amp;#64;NgStyleSheet. Implements IPageConfigurator.</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">2 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/glyphicons/glyphicons-page-configurator']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (5)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>250+ monochromatic icons &mdash; classic Bootstrap 3 Glyphicons Halflings set</p>
						<p waBody="s" waColorText="quiet" waText>Type-safe Java enum API &mdash; Glyphicons with compile-time safety</p>
						<p waBody="s" waColorText="quiet" waText>Glyphicon component &mdash; CRTP span-based icon element with IIcon interface</p>
						<p waBody="s" waColorText="quiet" waText>CSS web font rendering &mdash; glyphicon glyphicon-&#123;name&#125; CSS classes</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Create Glyphicons</h4>
							<p waBody="s" waColorText="quiet" waText>Use the Glyphicon component with type-safe enum.</p>
							<markdown [data]="mdContent_599" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_600" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>GlyphiconsPageConfigurator auto-registers Glyphicons CSS via npm</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: http://glyphicons.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/JWebMP</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>